<template>
    <div class="c-actions-list c-actions-list--vertical u-justify-content-center c-actions-cart" v-bind:class="{ first: isFirst }">
      <div class="c-actions-list__item" v-if="!isLogged">
        <button type="button" class="c-link c-link--theme-4 u-text-underline" @click="toggleOverlay">
          <span class="c-link__wrap">
            <span class="c-link__ico">
              <span class="o-ico o-ico--person o-ico--s">
                <svg aria-hidden="true"><use xlink:href="#ico-person-fill"></use></svg>
              </span>
            </span>
            <span class="c-link__label">Zaloguj się aby zapisać koszyk</span>
          </span>
        </button>
      </div>
    </div>
</template>

<script>
import { toggleCssClass } from '@/shared'

const $overlay = document.querySelector('.js-overlay')
const $body = document.querySelector('body')
let timer

export default {
  props: ['isLogged', 'linkOrder', 'isFirst'],
  methods: {
    toggleOverlay () {
      toggleCssClass($overlay, 'is-hidden')
      if (window.innerWidth < 767) {
        toggleCssClass($body, 'cart-opened')
      }
      this.$emit('toggleOpened')
      clearTimeout(timer)
      timer = setTimeout((e) => {
        this.openLogIn()
      }, 500)
    },

    openLogIn () {
      const eventClick = new Event('click')
      document.querySelector('.js-open-log-in').dispatchEvent(eventClick)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BlockCart/BlockCartActionsLog.vue